export const FETCH_ALLEXAMS_RESULT_STUDENT_REQUEST = 'FETCH_ALLEXAMS_RESULT_STUDENT_REQUEST'
export const FETCH_ALLEXAMS_RESULT_STUDENT_SUCCESS = 'FETCH_ALLEXAMS_RESULT_STUDENT_SUCCESS'
export const FETCH_ALLEXAMS_RESULT_STUDENT_FALIURE = 'FETCH_ALLEXAMS_RESULT_STUDENT_FALIURE'
